import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

export interface Output {
  field: string;
  value: string;
  fieldError?: string;
  valueError?: string;
  availableOptions?: { key: string; label: string }[];
}

export const validateOutputs = (
  outputs: Output[],
  t: TGlobalFunctionTyped,
  isValidateOnlyField = false,
): Output[] => {
  return outputs.map((output) => {
    const updatedOutput = { ...output };
    delete updatedOutput.fieldError;
    delete updatedOutput.valueError;

    if (!updatedOutput.field) {
      updatedOutput.fieldError = t(
        'bookkeep.integrations.settings.payableRules.errors.outputs.field',
      );
    } else if (!updatedOutput.value && !isValidateOnlyField) {
      updatedOutput.valueError = t(
        'bookkeep.integrations.settings.payableRules.errors.outputs.value',
      );
    }

    return updatedOutput;
  });
};

export const filterValidOutputs = (outputs: Output[]): Output[] => {
  return outputs.filter((output) => {
    const isFieldValid = output.field && output.field.trim() !== '';
    const isValueValid = output.value && output.value.trim() !== '';
    return isFieldValid && isValueValid;
  });
};
